import React, {useEffect, useState} from 'react';

import {Typography, useTheme} from '@mui/material';
import {
  Stack,
} from '@zoom/react-ui';
import {useTranslation} from 'react-i18next';
import {
  useSelector,
} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {ReactComponent as ThinCancel} from 'assets/svg/thin-cancel-x.svg';
import {ZmPrimaryLink} from 'Components/ZmLink/ZmLink';
import {ZmPopover} from 'Components/ZmPopover/ZmPopover';
import {isZoomieEmail} from 'Utils';
import {LOCAL_STORAGE_KEYS, PROVIDER_TYPE} from 'Utils/consts';
import {inZoomClient} from 'Utils/integration';
import {openUrlInBrowser, WEB_SCHEDULER_URL} from 'Utils/ZoomClientUtils';

export const AccountConfirmPopup = ({className, ...props}) => {
  const accounts = useSelector((state) => state.integrationState.accounts.value);
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const [hasBoundEmail, setHasBoundEmail] = useState(false);
  useEffect(() => {
    if (accounts.length > 0) {
      accounts.forEach((account) =>{
        // if one of the zoomie accounts is zmail and is the curently bind account
        // and showAddAccountPopup in local storage is not set
        // display popup with option to switch accounts
        if (isZoomieEmail(account.email) && account.service === PROVIDER_TYPE.ZOOM && account.pushEnabled) {
          if (localStorage.getItem(LOCAL_STORAGE_KEYS.SHOW_ADD_ACCOUNT_POPUP) === null) {
            setIsPopperOpen(true);
          };
        }
      });
      const boundEmail = accounts?.find((account) => account.pushEnabled);
      if (boundEmail) {
        setHasBoundEmail(true);
      } else {
        setIsPopperOpen(true);
      }
    }
  }, [accounts]);

  const theme = useTheme();
  const handleClose = () => {
    setIsPopperOpen(false);
    localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_ADD_ACCOUNT_POPUP, false);
  };

  return <ZmPopover
    {...props}
    sx={{
      zIndex: theme.zIndex.modal,
      ...props?.sx,
      width: '500px',
    }}
    title={<CustomLinkPopupContent
      handleClose={handleClose}
      hasBoundEmail={hasBoundEmail}
    />}
    open={isPopperOpen}
    placement="right"
    arrow
  />;
};

/**
 *
 * @param {Object} props
 * @return {ReactElement}
 */
function CustomLinkPopupContent(props) {
  const {handleClose, hasBoundEmail} = props;
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (<>
    <Stack style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <Typography variant="h4" sx={{
        margin: 0,
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600,
        overflowWrap: 'anywhere',
        // width: '300px',
      }}>
        {!hasBoundEmail ? t('integration.noBindAccountTitle') : t('landing.confirmAccount')}
      </Typography>
      <ThinCancel
        role="button"
        aria-label="cancelBtn"
        cursor={'pointer'}
        onClick={handleClose}
      />
    </Stack>
    <Typography variant="body2" sx={{
      margin: 0,
      marginTop: '4px',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 450,
      overflowWrap: 'anywhere',
    }}>
      {!hasBoundEmail ? t('integration.primaryAccountNotSet') : t('landing.confirmAccountDesc')}
    </Typography>
    <ZmPrimaryLink
      underline="hover"
      href=""
      onClick={(e) => {
        e.preventDefault();
        handleClose();
        if (inZoomClient) {
          openUrlInBrowser(`${WEB_SCHEDULER_URL}?action=settings-account`);
        } else {
          navigate('/me/settings/account');
        }
      }}
    >
      <Typography
        sx={{fontSize: '.875rem', fontWeight: 500}}
      >
        {!hasBoundEmail ? t('integration.setPrimary') : t('landing.changeAccount')}
      </Typography>
    </ZmPrimaryLink>
  </>);
}
